import { useEffect } from 'react'

import { FeatureType, ModuleType } from '../constants/template-info'
import QuinceError from '../domains/QuinceError'

const useCaptureDataException = ({
  captureException,
  errorMsg,
  name,
  errorInfo = {},
  additionalTags,
  module,
  feature,
}: {
  captureException: boolean
  errorMsg: string
  name: string
  errorInfo?: Record<string, any>
  additionalTags?: Record<string, any>
  module?: ModuleType
  feature?: FeatureType
}) => {
  useEffect(() => {
    if (captureException) {
      const error = new Error(errorMsg)
      error.name = name
      QuinceError.captureDataException(error, errorInfo, additionalTags, module, feature)
    }
  }, [additionalTags, captureException, errorInfo, errorMsg, feature, module, name])
}

export default useCaptureDataException
